import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const CREATE_PRACTICE = 'CREATE_PRACTICE';
export const CREATE_PRACTICE_SUCCESS = 'CREATE_PRACTICE_SUCCESS';
export const CREATE_PRACTICE_FAILURE = 'CREATE_PRACTICE_FAILURE';

// Action Creators
export const createPracticeRequest = () => ({
  type: CREATE_PRACTICE,
});

export const createPracticeSuccess = (users) => ({
  type: CREATE_PRACTICE_SUCCESS,
  payload: users,
});

export const createPracticeFailure = (error) => ({
  type: CREATE_PRACTICE_FAILURE,
  payload: error,
});

// Thunk Function
export const createPractice = (external, body) => {
  return async (dispatch) => {
    dispatch(createPracticeRequest());
    try {
      const response = await postMethodWithToken(url.createPractice, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(createPracticeSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(createPracticeFailure('error?.message'));
      }
    } catch (error) {
      dispatch(createPracticeFailure(error?.message));
    }
  };
};
